import React from 'react';
import { Card, CardBody, Row, Col, Badge } from 'reactstrap';
import { FaUserTie, FaVideo, FaChartLine, FaBell, FaChevronRight } from 'react-icons/fa';
import { FaTableList } from 'react-icons/fa6';

export default function SupervisorCard() {
  const DummyData = [
    {
      area_name: "AO-1",
      area_owner: "Adil",
      sub_area: "Roof Tops (Palletizing)",
      cameras: 1,
      compliance: 84,
      alerts: 10,
      supervisor_list: ["Umair Pervaiz", "Umair Pervaiz", "Umair Pervaiz", "Umair Pervaiz", "Umair Pervaiz", "Umair Pervaiz"]
    },
        {
      area_name: "AO-1",
      area_owner: "Adil",
      sub_area: "Roof Tops (Palletizing)",
      cameras: 1,
      compliance: 84,
      alerts: 10,
      supervisor_list: ["Umair Pervaiz", "Umair Pervaiz"]
    },
        {
      area_name: "AO-1",
      area_owner: "Adil",
      sub_area: "Roof Tops (Palletizing)",
      cameras: 1,
      compliance: 84,
      alerts: 10,
      supervisor_list: ["Umair Pervaiz", "Umair Pervaiz","Umair Pervaiz", "Umair Pervaiz", "Umair Pervaiz"]
    },
        {
      area_name: "AO-1",
      area_owner: "Adil",
      sub_area: "Roof Tops (Palletizing)",
      cameras: 1,
      compliance: 84,
      alerts: 10,
      supervisor_list: ["Umair Pervaiz", "Umair Pervaiz"]
    },
        {
      area_name: "AO-1",
      area_owner: "Adil",
      sub_area: "Roof Tops (Palletizing)",
      cameras: 1,
      compliance: 84,
      alerts: 10,
      supervisor_list: ["Umair Pervaiz", "Umair Pervaiz", "Umair Pervaiz", "Umair Pervaiz"]
    }, 
        {
      area_name: "AO-1",
      area_owner: "Adil",
      sub_area: "Roof Tops (Palletizing)",
      cameras: 1,
      compliance: 84,
      alerts: 10,
      supervisor_list: ["Umair Pervaiz", "Umair Pervaiz",]
    },
    
  ];

  return (
    <div>
        <Row> 
        <h1>Supervisors Details</h1>

      {DummyData?.length > 0 ? DummyData.map((data, index) => (
        <Col xxl="3" xl="4" lg="6" md="6" key={index}> 
        <Card key={index} style={cardStyle}>
          <CardBody style={cardBodyStyle}> 
            <Row style={headerStyle}>
              <Col xs={8}>
                <div style={titleSectionStyle}>
                  <h3 style={areaNameStyle}>{data.area_name}</h3>
                  <div style={ownerSectionStyle}>
                    <FaUserTie style={iconStyle} />
                    <span style={ownerTextStyle}>Area Owner: {data.area_owner}</span>
                  </div>
                </div>
              </Col>
              <Col xs={4} style={complianceSectionStyle}>
                <div style={complianceCircleStyle}>
                  <span style={complianceTextStyle}>{data.compliance}%</span>
                </div>
                <span style={complianceLabelStyle}>Compliance</span>
              </Col>
            </Row>
 
            <div style={subAreaStyle}>
              <span style={subAreaTextStyle}>{data.sub_area}</span>
            </div>
 
            <Row style={statsRowStyle}>
              <Col xs={4} style={statItemStyle}>
                <div style={statIconContainerStyle}>
                  <FaVideo style={statIconStyle} />
                </div>
                <div style={statTextContainerStyle}>
                  <span style={statNumberStyle}>{data.cameras}</span>
                  <span style={statLabelStyle}>Cameras</span>
                </div>
              </Col>
              
              <Col xs={4} style={statItemStyle}>
                <div style={statIconContainerStyle}>
                  <FaChartLine style={statIconStyle} />
                </div>
                <div style={statTextContainerStyle}>
                  <span style={statNumberStyle}>{data.compliance}%</span>
                  <span style={statLabelStyle}>Compliance</span>
                </div>
              </Col>
              
              <Col xs={4} style={statItemStyle}>
                <div style={statIconContainerStyle}>
                  <FaBell style={alertIconStyle} />
                </div>
                <div style={statTextContainerStyle}>
                  <span style={alertNumberStyle}>{data.alerts}</span>
                  <span style={statLabelStyle}>Alerts</span>
                </div>
              </Col>
            </Row>

            {/* Supervisors Section */}
            <div style={supervisorsSectionStyle}>
              <div style={supervisorsHeaderStyle}>
                <span style={supervisorsTitleStyle}>Supervisors</span>
                <Badge style={badgeStyle}>{data.supervisor_list.length}</Badge>
              </div>
              
              <div style={supervisorsListStyle}>
                {data.supervisor_list.map((supervisor, idx) => (
                  <div key={idx} style={supervisorItemStyle}>
                    <div style={avatarStyle}>
                      {supervisor.split(' ').map(n => n[0]).join('')}
                    </div>
                    <span style={supervisorNameStyle}>{supervisor}</span>
                  </div>
                ))}
                
                {/* {data.supervisor_list.length > 3 && (
                  <div style={moreSupervisorsStyle}>
                    <span style={moreTextStyle}>
                      +{data.supervisor_list.length - 3} more
                    </span>
                    <FaChevronRight style={chevronStyle} />
                  </div>
                )} */}
              </div>
            </div>
          </CardBody>
        </Card>
        </Col>
      )):
      <div className='border b-r-10 p-3 tect-center'>
        <h1>No Data Found</h1>
      </div>
      }
       </Row>
    </div>
  );
}

 

const cardStyle = {
  border: 'none',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  overflow: 'hidden',
  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  maxWidth: '500px', 
};

const cardBodyStyle = {
  padding: '24px'
};

const headerStyle = {
  marginBottom: '16px',
  alignItems: 'center'
};

const titleSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
};

const areaNameStyle = {
  fontSize: '28px',
  fontWeight: '700',
  color: '#2c3e50',
  margin: '0',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
};

const ownerSectionStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
};

const iconStyle = {
  color: '#6c757d',
  fontSize: '16px'
};

const ownerTextStyle = {
  fontSize: '14px',
  color: '#6c757d',
  fontWeight: '500'
};

const complianceSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

const complianceCircleStyle = {
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
};

const complianceTextStyle = {
  color: 'white',
  fontSize: '16px',
  fontWeight: '700'
};

const complianceLabelStyle = {
  fontSize: '12px',
  color: '#6c757d',
  marginTop: '4px',
  fontWeight: '500'
};

const subAreaStyle = {
  marginBottom: '20px',
  padding: '12px 16px',
  backgroundColor: '#e3f2fd',
  borderRadius: '12px',
  border: '1px solid #bbdefb'
};

const subAreaTextStyle = {
  fontSize: '14px',
  color: '#1976d2',
  fontWeight: '600'
};

const statsRowStyle = {
  marginBottom: '24px'
};

const statItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center'
};

const statIconContainerStyle = {
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  backgroundColor: '#f0f4f8',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '8px'
};

const statIconStyle = {
  fontSize: '20px',
  color: '#3498db'
};

const alertIconStyle = {
  fontSize: '20px',
  color: '#e74c3c'
};

const statTextContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px'
};

const statNumberStyle = {
  fontSize: '20px',
  fontWeight: '700',
  color: '#2c3e50'
};

const alertNumberStyle = {
  fontSize: '20px',
  fontWeight: '700',
  color: '#e74c3c'
};

const statLabelStyle = {
  fontSize: '12px',
  color: '#6c757d',
  fontWeight: '500'
};

const supervisorsSectionStyle = {
  borderTop: '2px solid #e9ecef',
  paddingTop: '20px'
};

const supervisorsHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px'
};

const supervisorsTitleStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#2c3e50'
};

const badgeStyle = {
  backgroundColor: '#3498db',
  color: 'white',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: '600',
  padding: '4px 8px'
};

const supervisorsListStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  height: '150px',
  overflowY: 'auto',
  alignItems: 'center', 
};

const supervisorItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '8px 12px',
  backgroundColor: '#f8f9fa',
  borderRadius: '8px',
  transition: 'background-color 0.2s ease',
  width: '100%'
};

const avatarStyle = {
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: '#3498db',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '12px',
  fontWeight: '600'
};

const supervisorNameStyle = {
  fontSize: '14px',
  color: '#2c3e50',
  fontWeight: '500'
};

const moreSupervisorsStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 12px',
  backgroundColor: '#e3f2fd',
  borderRadius: '8px',
  cursor: 'pointer'
};

const moreTextStyle = {
  fontSize: '14px',
  color: '#1976d2',
  fontWeight: '500'
};

const chevronStyle = {
  fontSize: '12px',
  color: '#1976d2'
};